
import api from '../../../api/axios';

const basePath = (slug) =>
  `/admin/cronometraje/${encodeURIComponent(slug)}`;

export const cronometrajeAdminService = {
  async getConfig(slug) {
    const response = await api.get(`${basePath(slug)}/config`);
    return response.data;
  },

  async saveConfig(slug, data) {
    const response = await api.put(`${basePath(slug)}/config`, data);
    return response.data;
  },

  async activate(slug) {
    const response = await api.post(`${basePath(slug)}/activate`);
    return response.data;
  },

  async deactivate(slug) {
    const response = await api.post(`${basePath(slug)}/deactivate`);
    return response.data;
  },

  async setPublication(slug, publicar_resultados) {
    const response = await api.put(
      `${basePath(slug)}/publication`,
      { publicar_resultados }
    );
    return response.data;
  },

  async getLivePreview(slug) {
    const response = await api.get(
      `${basePath(slug)}/live-preview`
    );
  
    return response.data;
  },

  async finalizeLiveResults(slug) {
    const response = await api.post(
      `${basePath(slug)}/finalize-live-results`
    );

    return response.data;
  },

};


export default cronometrajeAdminService;
